import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Logo from "../components/common/logo";
import WorkExperience from "../components/work/workExperience";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/work.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "work");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Work | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="work" />
				<div className="content-wrapper">
					<div className="work-logo-container">
						<div className="work-logo">
							<Logo width={40} />
						</div>
					</div>
					<div className="work-container">
						<div className="title work-title">
							My Professional Journey
						</div>

						<div className="subtitle work-subtitle">
							Here's a timeline of my work experience.
						</div>

						<div className="work-experience-list">
							<WorkExperience />
						</div>
					</div>

					<div className="page-footer">
						<div className="copyright">
							{INFO.copyright}
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
